import { channelPartnerRequestQueryKeys as e } from "./useChannelPartnerRequestQueryKeys.mjs";
import { useInfiniteListQuery as t, useQueryClient as n } from "@maat/store-hooks";
import { adminChannelPartnerRequestsApi as r } from "@maat/api-main";
//#region src/channelPartnerRequests/useChannelPartnerRequestLogQuery.ts
var i = 50, a = 1e4, o = (o, s = {}) => {
	let c = n(), l = e.log(o), u = t({
		queryKey: l,
		fetchPage: (e) => r.list({
			...o,
			page: e,
			pageSize: i
		}),
		key: "items",
		enabled: s.enabled ?? !0,
		refetchInterval: (e) => s.live && (e.state.data?.pages.length ?? 0) <= 1 ? a : !1,
		refetchIntervalInBackground: !1
	}), d = () => c.resetQueries({
		queryKey: l,
		exact: !0
	});
	return {
		...u,
		resetToNewest: d
	};
};
//#endregion
export { o as useChannelPartnerRequestLogQuery };
